import type { FunctionComponent } from "react";

import type { StyledProps } from "./styles";
import { Container, Duration, Icon } from "./styles";

type Props = PropsFromStyledProps<StyledProps> & {
  className?: string;
  duration: string;
};

export const DefaultVideoDurationOverlay: FunctionComponent<Props> = ({
  className,
  duration,
  responsiveVariants,
}) => (
  <Container $responsiveVariants={responsiveVariants} className={className}>
    <Icon /> <Duration>{duration}</Duration>
  </Container>
);
